/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
// import { csv } from "d3-fetch";
import { scaleLinear } from 'd3-scale';
import {
  ComposableMap,
  Geographies,
  Geography,
  ZoomableGroup,
  Sphere,
  Graticule,
} from 'react-simple-maps';
import features from './features.json';
import ReactTooltip from 'react-tooltip';
import { Card } from 'react-bootstrap';
import { message } from 'antd';
const geoUrl = features;

const DEFAULT_COLOR = '#000000';
export interface IChoroplethMapWidgetProps {
  data?: any[];
  highest?: any;
  message?: string;
}

export const ChoroplethMapWidget = ({
  data,
  highest,
  message,
}: IChoroplethMapWidgetProps) => {
  const [tooltipContent, setTooltipContent] = useState('');
  const colorScale = scaleLinear()
    .domain([0, highest])
    .range(['#ffedea', '#800000']);

  const onMouseEnter = (geo: any, current = { count: 'NA' }) => {
    return () => {
      setTooltipContent(`${geo.properties.name}: ${current.count}`);
    };
  };

  const onMouseLeave = () => {
    setTooltipContent('');
  };
  const geographyStyle = {
    default: {
      outline: 'none',
    },
    hover: {
      fill: '#ccc',
      transition: 'all 250ms',
      outline: 'none',
    },
    pressed: {
      outline: 'none',
    },
  };
  return (
    <>
      <Card border="0" className="shadow">
        {message && (
          <Card.Header>
            <div>
              <h4 style={{ textAlign: 'center' }}>{message}</h4>
            </div>
          </Card.Header>
        )}
        <ReactTooltip>{tooltipContent}</ReactTooltip>
        <ComposableMap
          projectionConfig={{
            rotate: [-10, 0, 0],
            scale: 147,
          }}
          // projection="geoMercator"
          data-tip=""
        >
          <ZoomableGroup>
            {/* <Sphere stroke="#E4E5E6" strokeWidth={0.5} />
      <Graticule stroke="#E4E5E6" strokeWidth={0.5} /> */}
            {data.length > 0 && (
              <Geographies geography={geoUrl}>
                {({ geographies }) =>
                  geographies.map((geo) => {
                    const d = data.find((s) => s.ISO3 === geo.id);
                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        fill={d ? colorScale(d['count']) : DEFAULT_COLOR}
                        style={geographyStyle}
                        onMouseEnter={onMouseEnter(geo, d)}
                        onMouseLeave={onMouseLeave}
                      />
                    );
                  })
                }
              </Geographies>
            )}
          </ZoomableGroup>
        </ComposableMap>
      </Card>
    </>
  );
};

ChoroplethMapWidget.defaultProps = {};
